module.exports = __webpack_public_path__ + "assets/b4df928f728cd0d50a640633e5d6fdaf.svg";